import {Component} from '@angular/core';
import {TranslateService} from '@ngx-translate/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';

import {getTranslation} from 'shared/helpers/get-translation';
import {NavService} from 'shared/nav/nav.service';

import {Dialog} from '../../model/model';

import { Browser } from '@capacitor/browser';
import { Observable, of } from 'rxjs';
import { DefaultPage } from 'app/menu/components/default-page/default-page';

@Component({
  selector: 'dialogs-detail-page',
  templateUrl: 'dialogs-detail-page.html',
  styleUrls: ['dialogs-detail-page.scss'],
})
export class DialogsDetailPage extends DefaultPage {

  private dialog: Dialog;
  public parsedDescription: string = '';
  public contentInfo: string = '';

  public get dialogTitle(): string {
    if (this.dialog) {
      if (this.dialog.fullGoal !== undefined && this.dialog.fullGoal.dialog === undefined) {
        return this.dialog.fullGoal.title;
      }

      return getTranslation(this.dialog.title, this.translateService);
    }

    return '';
  }

  public get dialogDescription(): string {
    if (this.dialog) {

      return getTranslation(this.dialog.description, this.translateService)
        .replace('http://www.synk-group.com', 'https://www.synk-group.com'); // fix http vs https
    }

    return '';
  }

  public get hasGoalId(): boolean {
    return this.dialog.goalId !== undefined;
  }

  constructor(
    private navService: NavService,
    private translateService: TranslateService,
    private sanitizer: DomSanitizer,
  ) {
    super(navService);
    this.dialog = <Dialog> this.navService.get('dialog');

    if (this.dialog.fullGoal !== undefined && this.dialog.fullGoal.dialog === undefined) {
      this.parsedDescription = this.escapeHtml(this.dialog.fullGoal.description);
    }

    if ( this.dialog.contentInfo ) {
      this.translateService.get('DIALOGS.CONTENT').subscribe((translation) => {
        this.contentInfo = translation + ': ' + getTranslation(this.dialog.contentInfo.title, this.translateService) 
          + ' (' + (this.dialog.contentInfo.pos+1) + ' / ' + this.dialog.contentInfo.length + ')';
      });
    }
    else {
      this.contentInfo = '';
    }

  }

  public onNextClick(): void {
    if (this.dialog.fullGoal !== undefined && this.dialog.fullGoal.dialog === undefined) {
      this.navService.root('goals/feedback', {dialog: this.dialog});
    } else {
      this.navService.push('dialogs/questions', { dialog: this.dialog });
    }
  }

  public interceptClick(event: Event): void {
    const target: HTMLElement = <HTMLElement> event.target;
    if (!(target instanceof HTMLAnchorElement) && !(target.parentElement instanceof HTMLAnchorElement)) {
      return;
    }

    event.preventDefault();
    event.stopImmediatePropagation();

    const anchor: HTMLAnchorElement = <HTMLAnchorElement> (target.tagName === 'A' ? target : target.parentElement);
    const href = anchor.href;
    if ( href.indexOf('https://dummy.de/') == 0) {
      this.navService.push('content', {selContentTitle: decodeURI(href.substring(17))});
    }
    else {
      Browser.open({url: href});
    }
  }

  private escapeHtml(s: string): string {
    return s
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;')
        .replace(/'/g, '&#039;');
  }

}
